import { Box, Typography, Link } from "@mui/material";
import internalReach from "assets/images/background/internal-reach.png";
import { useParams } from "react-router";
import { Link as RouterLink } from "react-router-dom";
import { Navigate } from 'react-router-dom';
import { blogs } from "views/Blog/data";
import { useState } from "react";
import { BookAppointmentModel } from "components";

import { Helmet } from 'react-helmet-async';

import img1 from "assets/images/blog/1.jpg";
import img2 from "assets/images/blog/2.jpg";
import img3 from "assets/images/blog/3.jpg";
import img4 from "assets/images/blog/4.jpg";

import img5 from "assets/images/blog/5.jpg";
import img6 from "assets/images/blog/6.jpg";
import img7 from "assets/images/blog/7.jpg";
import img8 from "assets/images/blog/8.jpg";

import img9 from "assets/images/blog/9.jpg";
import img10 from "assets/images/blog/10.jpg";
import img11 from "assets/images/blog/11.jpg";
import img12 from "assets/images/blog/12.jpg";
import img13 from "assets/images/blog/13.jpg";
import img14 from "assets/images/blog/14.jpg";
import img15 from "assets/images/blog/15.jpg";
import img16 from "assets/images/blog/16.jpg";
import img17 from "assets/images/blog/17.jpg";
import img18 from "assets/images/blog/18.jpg";
import img19 from "assets/images/blog/19.jpg";
import img20 from "assets/images/blog/20.jpg";
import img21 from "assets/images/blog/21.jpg";
import img22 from "assets/images/blog/22.jpg";
import img23 from "assets/images/blog/23.jpg";
import img24 from "assets/images/blog/24.jpg";



const BlogItem = ({ img, title }) => {
  return (

    


    <Box display="flex" mb={3} alignItems={{ xs: "center", md: "start" }}>
      <Box
        pr={3}
        minWidth={"8.75rem"}
        maxWidth={"8.75rem"}
        textAlign={{ xs: "center", md: "start" }}
      >
        <img
          src={img}
          alt="blog"
          width="100%"
          height={"100%"}
          style={{ objectFit: "cover", borderRadius: "0.5rem" }}
        />
      </Box>
      <Box>
        <Typography fontSize="0.85rem" fontWeight="bold" mb={2}>
          {title}
        </Typography>
      </Box>
    </Box>
  );
};

const Details = () => {
  const { slug } = useParams();
  const selectedBlog = blogs.find((item) => item.slug === slug);
  const [openModel, setOpenModel] = useState(false);
  const openPopup = () => setOpenModel(true);
  const closePopup = () => setOpenModel(false);
  if (!selectedBlog) return <Navigate to="/404" replace />;
  
  return (
    <Box
      px={{ xs: 4, lg: 10 }}
      py={{ xs: 4, lg: 8 }}
      display="flex"
      flexDirection={{ xs: "column", lg: "row" }}
    >
     <Helmet>
      <title>{selectedBlog?.title}</title>
      <meta name="description" content={selectedBlog?.description || "Blog post detail page"} />
    </Helmet>
      <Box pr={{ xs: 0, lg: 5 }}>
  <img
    src={selectedBlog.img}
    alt="blog"
    width={"100%"}
    style={{ borderRadius: "1rem" }}
  />
  <Typography component="h1" fontSize="2.75rem" fontWeight="bold" py={4}>
    {selectedBlog.header}
  </Typography>

  {selectedBlog.data?.map((item, i) => (
    <Box key={`data-${i}`}>
      {item.subheader && (
        <Typography
          color="#777"
          fontWeight={"bold"}
          variant="h6"
          component="h2"
          mb={3}
        >
          {item.subheader}
        </Typography>
      )}
      {item.text && (
        <Typography color="#777" fontSize="1.4rem" mb={3}>
          {item.text}
        </Typography>
      )}
      {item.text1 && (
        <Typography color="#777" fontSize="1.4rem" mb={3}>
          {item.text1}
        </Typography>
      )}
      {item.text2 && (
        <Typography color="#777" fontSize="1.4rem" mb={3}>
          {item.text2}
        </Typography>
      )}
      {item.text3 && (
        <Typography color="#777" fontSize="1.4rem" mb={3}>
          {item.text3}
        </Typography>
      )}
      {item.text4 && (
        <Typography color="#777" fontSize="1.4rem" mb={3}>
          {item.text4}
        </Typography>
      )}
      {item.text5 && (
        <Typography color="#777" fontSize="1.4rem" mb={3}>
          {item.text5}
        </Typography>
      )}
    </Box>
  ))}

  {/* 👇 yaha doctor card aa jayega */}
  {selectedBlog.doctor && (
    <Box
      display="flex"
      alignItems="center"
      p={2}
      border="1px solid #e8e8e8"
      borderRadius="12px"
      bgcolor="#fafafa"
      mb={3}
    >
      <img
        src={selectedBlog.doctor.photo}
        alt={selectedBlog.doctor.name}
        style={{
          width: 72,
          height: 72,
          borderRadius: "50%",
          marginRight: "1rem",
          objectFit: "cover",
        }}
      />
      <Box>
        <Typography fontSize=".9rem" color="text.secondary" mb={0.5}>
          Written and Verified by:
        </Typography>
        <Typography fontWeight={700} lineHeight={1.2} mb={0.5}>
          {selectedBlog.doctor.name}{" "}
          <Typography component="span" color="text.secondary" fontWeight={500}>
            &nbsp;Exp: {selectedBlog.doctor.exp}
          </Typography>
        </Typography>
        <Typography color="text.secondary" mb={0.5}>
          {selectedBlog.doctor.specialty}
        </Typography>
        <Link
          component={RouterLink}
          to={selectedBlog.doctor.profileUrl}
          underline="hover"
          fontWeight={700}
        >
          Meet the doctor
        </Link>
      </Box>
    </Box>
  )}
  {selectedBlog.doctor2 && (
    <Box
      display="flex"
      alignItems="center"
      p={2}
      border="1px solid #e8e8e8"
      borderRadius="12px"
      bgcolor="#fafafa"
      mb={3}
    >
      <img
        src={selectedBlog.doctor2.photo}
        alt={selectedBlog.doctor2.name}
        style={{
          width: 72,
          height: 72,
          borderRadius: "50%",
          marginRight: "1rem",
          objectFit: "cover",
        }}
      />
      <Box>
        <Typography fontSize=".9rem" color="text.secondary" mb={0.5}>
          Written and Verified by:
        </Typography>
        <Typography fontWeight={700} lineHeight={1.2} mb={0.5}>
          {selectedBlog.doctor2.name}{" "}
          <Typography component="span" color="text.secondary" fontWeight={500}>
            &nbsp;Exp: {selectedBlog.doctor2.exp}
          </Typography>
        </Typography>
        <Typography color="text.secondary" mb={0.5}>
          {selectedBlog.doctor2.specialty}
        </Typography>
        <Link
          component={RouterLink}
          to={selectedBlog.doctor2.profileUrl}
          underline="hover"
          fontWeight={700}
        >
          Meet the doctor
        </Link>
      </Box>
    </Box>
  )}
  {selectedBlog.doctor3 && (
    <Box
      display="flex"
      alignItems="center"
      p={2}
      border="1px solid #e8e8e8"
      borderRadius="12px"
      bgcolor="#fafafa"
      mb={3}
    >
      <img
        src={selectedBlog.doctor3.photo}
        alt={selectedBlog.doctor3.name}
        style={{
          width: 72,
          height: 72,
          borderRadius: "50%",
          marginRight: "1rem",
          objectFit: "cover",
        }}
      />
      <Box>
        <Typography fontSize=".9rem" color="text.secondary" mb={0.5}>
          Written and Verified by:
        </Typography>
        <Typography fontWeight={700} lineHeight={1.2} mb={0.5}>
          {selectedBlog.doctor3.name}{" "}
          <Typography component="span" color="text.secondary" fontWeight={500}>
            &nbsp;Exp: {selectedBlog.doctor3.exp}
          </Typography>
        </Typography>
        <Typography color="text.secondary" mb={0.5}>
          {selectedBlog.doctor3.specialty}
        </Typography>
        <Link
          component={RouterLink}
          to={selectedBlog.doctor3.profileUrl}
          underline="hover"
          fontWeight={700}
        >
          Meet the doctor
        </Link>
      </Box>
    </Box>
  )}
  {selectedBlog.doctor4 && (
    <Box
      display="flex"
      alignItems="center"
      p={2}
      border="1px solid #e8e8e8"
      borderRadius="12px"
      bgcolor="#fafafa"
      mb={3}
    >
      <img
        src={selectedBlog.doctor4.photo}
        alt={selectedBlog.doctor4.name}
        style={{
          width: 72,
          height: 72,
          borderRadius: "50%",
          marginRight: "1rem",
          objectFit: "cover",
        }}
      />
      <Box>
        <Typography fontSize=".9rem" color="text.secondary" mb={0.5}>
          Written and Verified by:
        </Typography>
        <Typography fontWeight={700} lineHeight={1.2} mb={0.5}>
          {selectedBlog.doctor4.name}{" "}
          <Typography component="span" color="text.secondary" fontWeight={500}>
            &nbsp;Exp: {selectedBlog.doctor4.exp}
          </Typography>
        </Typography>
        <Typography color="text.secondary" mb={0.5}>
          {selectedBlog.doctor4.specialty}
        </Typography>
        <Link
          component={RouterLink}
          to={selectedBlog.doctor4.profileUrl}
          underline="hover"
          fontWeight={700}
        >
          Meet the doctor
        </Link>
      </Box>
    </Box>
  )}
  {selectedBlog.doctor5 && (
    <Box
      display="flex"
      alignItems="center"
      p={2}
      border="1px solid #e8e8e8"
      borderRadius="12px"
      bgcolor="#fafafa"
      mb={3}
    >
      <img
        src={selectedBlog.doctor5.photo}
        alt={selectedBlog.doctor5.name}
        style={{
          width: 72,
          height: 72,
          borderRadius: "50%",
          marginRight: "1rem",
          objectFit: "cover",
        }}
      />
      <Box>
        <Typography fontSize=".9rem" color="text.secondary" mb={0.5}>
          Written and Verified by:
        </Typography>
        <Typography fontWeight={700} lineHeight={1.2} mb={0.5}>
          {selectedBlog.doctor5.name}{" "}
          <Typography component="span" color="text.secondary" fontWeight={500}>
            &nbsp;Exp: {selectedBlog.doctor5.exp}
          </Typography>
        </Typography>
        <Typography color="text.secondary" mb={0.5}>
          {selectedBlog.doctor5.specialty}
        </Typography>
        <Link
          component={RouterLink}
          to={selectedBlog.doctor5.profileUrl}
          underline="hover"
          fontWeight={700}
        >
          Meet the doctor
        </Link>
      </Box>
    </Box>
  )}
  {selectedBlog.doctor6 && (
    <Box
      display="flex"
      alignItems="center"
      p={2}
      border="1px solid #e8e8e8"
      borderRadius="12px"
      bgcolor="#fafafa"
      mb={3}
    >
      <img
        src={selectedBlog.doctor6.photo}
        alt={selectedBlog.doctor6.name}
        style={{
          width: 72,
          height: 72,
          borderRadius: "50%",
          marginRight: "1rem",
          objectFit: "cover",
        }}
      />
      <Box>
        <Typography fontSize=".9rem" color="text.secondary" mb={0.5}>
          Written and Verified by:
        </Typography>
        <Typography fontWeight={700} lineHeight={1.2} mb={0.5}>
          {selectedBlog.doctor6.name}{" "}
          <Typography component="span" color="text.secondary" fontWeight={500}>
            &nbsp;Exp: {selectedBlog.doctor6.exp}
          </Typography>
        </Typography>
        <Typography color="text.secondary" mb={0.5}>
          {selectedBlog.doctor6.specialty}
        </Typography>
        <Link
          component={RouterLink}
          to={selectedBlog.doctor6.profileUrl}
          underline="hover"
          fontWeight={700}
        >
          Meet the doctor
        </Link>
      </Box>
    </Box>
  )}
</Box>

      

      <Box
        flexGrow={1}
        maxWidth={{ xs: "100%", lg: "24.5rem" }}
        minWidth={{ xs: "100%", lg: "24.5rem" }}
      >
        <Box bgcolor="#f4f4f4" px={3} pb={0.25} borderRadius="1rem" mb={3}>
          <Typography
            variant="body2"
            textTransform="uppercase"
            borderBottom={1}
            mx={-3}
            px={3}
            py={2}
            borderColor="#e8e8e8"
            fontWeight={600}
            mb={3}
          >
            Latest post
          </Typography>
          <Link
            component={RouterLink}
            to="/blog/endoscopic-thyroid"
            textDecoration="none"
            color="common.black"
            sx={{
              textDecoration: "none",
              "&:hover": {
                textDecoration: "none",
              },
            }}
          >
            <BlogItem
              img={img1}
              title="Chennai’s Leading Endoscopic Thyroid Surgery at Amrit Hospital"
            />
          </Link>
          <Link
            component={RouterLink}
            to="/blog/regular-eye-check-ups"
            textDecoration="none"
            color="common.black"
            sx={{
              textDecoration: "none",
              "&:hover": {
                textDecoration: "none",
              },
            }}
          >
            <BlogItem
              img={img2}
              title="The Importance of Regular Eye Check-Ups"
              text="The Importance of Regular Eye Check-Ups: How Amrit Hospital's Ophthalmology Department Ensures Clear Vision for Life"
            />
          </Link>
          <Link
            component={RouterLink}
            to="/blog/multi-specialty-healthcare"
            textDecoration="none"
            color="common.black"
            sx={{
              textDecoration: "none",
              "&:hover": {
                textDecoration: "none",
              },
            }}
          >
            <BlogItem
              img={img3}
              title="Navigating Multi-Specialty Healthcare"
              text="Navigating Multi-Specialty Healthcare: Why Amrit Hospital Is Your One-Stop Solution for All Medical Needs"
            />
          </Link>
          <Link
            component={RouterLink}
            to="/blog/expert-cataract-surgery"
            textDecoration="none"
            color="common.black"
            sx={{
              textDecoration: "none",
              "&:hover": {
                textDecoration: "none",
              },
            }}
          >
            <BlogItem
              img={img4}
              title="Cataracts are one of the leading causes of vision impairment, particularly in older adults."
              text="Cataracts occur when the eye’s natural lens becomes cloudy, leading to blurred vision, difficulty with glare, and eventually, significant vision impairment. "
            />
          </Link>

          <Link
            component={RouterLink}
            to="/blog/cataract-surgery"
            textDecoration="none"
            color="common.black"
            sx={{
              textDecoration: "none",
              "&:hover": {
                textDecoration: "none",
              },
            }}
          >
            <BlogItem
              img={img5}
              title="5 Cataract Surgery Side Effects & How to Recover"
            />
          </Link>

          <Link
            component={RouterLink}
            to="/blog/foods-for-eye-health"
            textDecoration="none"
            color="common.black"
            sx={{
              textDecoration: "none",
              "&:hover": {
                textDecoration: "none",
              },
            }}
          >
            <BlogItem img={img6} title="5 Best Foods for Eye Health" />
          </Link>

          <Link
            component={RouterLink}
            to="/blog/femto-laser-cataract"
            textDecoration="none"
            color="common.black"
            sx={{
              textDecoration: "none",
              "&:hover": {
                textDecoration: "none",
              },
            }}
          >
            <BlogItem
              img={img7}
              title="Femto Laser Cataract Surgery: Revolutionizing Modern Cataract Treatment"
            />
          </Link>

          <Link
            component={RouterLink}
            to="/blog/post-cataract-surgery"
            textDecoration="none"
            color="common.black"
            sx={{
              textDecoration: "none",
              "&:hover": {
                textDecoration: "none",
              },
            }}
          >
            <BlogItem
              img={img8}
              title="Post Cataract Surgery Precautions & Recovery"
            />
          </Link>
          <Link
            component={RouterLink}
            to="/blog/child-growth-and-development"
            textDecoration="none"
            color="common.black"
            sx={{
              textDecoration: "none",
              "&:hover": {
                textDecoration: "none",
              },
            }}
          >
            <BlogItem
              img={img9}
              title="5 Important Stages of Child Growth and Development"
            />
          </Link>
          <Link
            component={RouterLink}
            to="/blog/fertility-in-women"
            textDecoration="none"
            color="common.black"
            sx={{
              textDecoration: "none",
              "&:hover": {
                textDecoration: "none",
              },
            }}
          >
            <BlogItem
              img={img10}
              title="10 Foods That Increase Fertility in Women"
            />
          </Link>

          <Link
            component={RouterLink}
            to="/blog/apple-cider-vinegar-during-pregnancy"
            textDecoration="none"
            color="common.black"
            sx={{
              textDecoration: "none",
              "&:hover": {
                textDecoration: "none",
              },
            }}
          >
            <BlogItem
              img={img11}
              title="Apple Cider Vinegar During Pregnancy: Good or Bad?"
            />
          </Link>

          <Link
            component={RouterLink}
            to="/blog/cosmetic-gynaecology"
            textDecoration="none"
            color="common.black"
            sx={{
              textDecoration: "none",
              "&:hover": {
                textDecoration: "none",
              },
            }}
          >
            <BlogItem
              img={img12}
              title="Cosmetic Gynaecology: Everything You Need to Know"
            />
          </Link>

          <Link
            component={RouterLink}
            to="/blog/avoid-c-section"
            textDecoration="none"
            color="common.black"
            sx={{
              textDecoration: "none",
              "&:hover": {
                textDecoration: "none",
              },
            }}
          >
            <BlogItem
              img={img13}
              title="Normal Delivery Tips: What to Do to Avoid a C-Section"
            />
          </Link>
          <Link
            component={RouterLink}
            to="/blog/renal-calculi-patients"
            textDecoration="none"
            color="common.black"
            sx={{
              textDecoration: "none",
              "&:hover": {
                textDecoration: "none",
              },
            }}
          >
            <BlogItem
              img={img14}
              title="Best Diet for Renal Calculi Patients: How to Prevent Recurrence"
            />
          </Link>
          <Link
            component={RouterLink}
            to="/blog/fungal-ear-infection"
            textDecoration="none"
            color="common.black"
            sx={{
              textDecoration: "none",
              "&:hover": {
                textDecoration: "none",
              },
            }}
          >
            <BlogItem
              img={img15}
              title="Signs of a Fungal Ear Infection: How to Identify and Treat It"
            />
          </Link>
          <Link
            component={RouterLink}
            to="/blog/gallbladder-stone-disease"
            textDecoration="none"
            color="common.black"
            sx={{
              textDecoration: "none",
              "&:hover": {
                textDecoration: "none",
              },
            }}
          >
            <BlogItem
              img={img16}
              title="Understanding Gallbladder Stone Disease: What You Need to Know"
            />
          </Link>
          <Link
            component={RouterLink}
            to="/blog/hair-fall-treatment"
            textDecoration="none"
            color="common.black"
            sx={{
              textDecoration: "none",
              "&:hover": {
                textDecoration: "none",
              },
            }}
          >
            <BlogItem
              img={img17}
              title="Hair Fall Treatment Solutions: Medical and Natural Remedies That Work"
            />
          </Link>
          <Link
            component={RouterLink}
            to="/blog/lump-behind-ear"
            textDecoration="none"
            color="common.black"
            sx={{
              textDecoration: "none",
              "&:hover": {
                textDecoration: "none",
              },
            }}
          >
            <BlogItem
              img={img18}
              title="Lump Behind Ear: Causes, Symptoms, and When to See a Doctor"
            />
          </Link>
          <Link
            component={RouterLink}
            to="/blog/pinched-nerve-in-shoulder-blade"
            textDecoration="none"
            color="common.black"
            sx={{
              textDecoration: "none",
              "&:hover": {
                textDecoration: "none",
              },
            }}
          >
            <BlogItem
              img={img19}
              title="Pinched Nerve in the Shoulder Blade: Causes, Symptoms, and Treatment"
            />
          </Link>
          <Link
            component={RouterLink}
            to="/blog/lower-back-pain-in-women"
            textDecoration="none"
            color="common.black"
            sx={{
              textDecoration: "none",
              "&:hover": {
                textDecoration: "none",
              },
            }}
          >
            <BlogItem
              img={img20}
              title="Preventive Measures for Lower Back Pain in Women"
            />
          </Link>
          <Link
            component={RouterLink}
            to="/blog/small-white-patches-on-skin"
            textDecoration="none"
            color="common.black"
            sx={{
              textDecoration: "none",
              "&:hover": {
                textDecoration: "none",
              },
            }}
          >
            <BlogItem
              img={img21}
              title="Preventive Measures for Lower Back Pain in Women"
            />
          </Link>
          <Link
            component={RouterLink}
            to="/blog/tiny-red-spots-on-skin"
            textDecoration="none"
            color="common.black"
            sx={{
              textDecoration: "none",
              "&:hover": {
                textDecoration: "none",
              },
            }}
          >
            <BlogItem
              img={img22}
              title="Tiny Red Spots on Skin: Are They Harmless or a Sign of an Underlying Condition?"
            />
          </Link>
          <Link
            component={RouterLink}
            to="/blog/pyelonephritis-severe-kidney-infection"
            textDecoration="none"
            color="common.black"
            sx={{
              textDecoration: "none",
              "&:hover": {
                textDecoration: "none",
              },
            }}
          >
            <BlogItem
              img={img23}
              title="Understanding Pyelonephritis: A Severe Kidney Infection Explained"
            />
          </Link>
          <Link
            component={RouterLink}
            to="/blog/musculoskeletal-pain"
            textDecoration="none"
            color="common.black"
            sx={{
              textDecoration: "none",
              "&:hover": {
                textDecoration: "none",
              },
            }}
          >
            <BlogItem
              img={img24}
              title="Understanding Musculoskeletal Pain: A Complete Guide"
            />
          </Link>
        </Box>

        <Box
          order={{ xs: -1, md: 2 }}
          maxWidth={{ xs: "100%", md: "24.5rem" }}
          minWidth={{ xs: "100%", md: "24.5rem" }}
          position={"relative"}
        >
          <img
            src={internalReach}
            alt="internalReach"
            width="100%"
            onClick={openPopup}
            style={{ cursor: "pointer" }}
          />
          <Link
            to="tel:+919600711818"
            alignItems="center"
            component={RouterLink}
            sx={{
              textDecoration: "none",
              width: "100%",
              height: "30px",
              display: "block",
              position: "absolute",
              bottom: "33%",
              zIndex: 1,
            }}
            color={"common.black"}
          ></Link>
        </Box>
      </Box>
      {openModel && <BookAppointmentModel onClose={closePopup} />}
    </Box>
  );
};

export default Details;
